var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row items-center self-end px-2 py-1 rounded-md",class:{
    'bg-level-h-light': _vm.status === 'Blocked',
    'bg-level-m-light': _vm.status === 'Pending',
    'bg-level-l-light': _vm.status === 'Active',
  }},[_c('p',{staticClass:"text-base font-medium capitalize tracking-wide",class:{
      'text-level-h': _vm.status === 'Blocked',
      'text-level-m-bold': _vm.status === 'Pending',
      'text-level-l': _vm.status === 'Active',
    }},[_vm._v(" "+_vm._s(_vm._f("lowercase")(_vm.status))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }